import { QuestionResponse } from "@/entities/support/api/questions-api";

export interface UpdateQuestionInput {
  title: string;
  content: string;
  category: string;
}

/**
 * 문의 수정 Use Case
 * 입력 검증 → API 호출 → 응답 처리
 */
export class UpdateQuestionUseCase {
  validateInput(input: UpdateQuestionInput): void {
    if (!input.title.trim()) {
      throw new Error("제목을 입력해주세요");
    }
    if (!input.content.trim()) {
      throw new Error("내용을 입력해주세요");
    }
    if (input.title.length < 2) {
      throw new Error("제목은 2글자 이상이어야 합니다");
    }
    if (input.content.length < 5) {
      throw new Error("내용은 5글자 이상이어야 합니다");
    }
  }

  async execute(
    questionId: string,
    input: UpdateQuestionInput
  ): Promise<QuestionResponse> {
    // 입력 검증
    this.validateInput(input);

    // Hook에서 API 호출을 수행하도록 설계
    // (use-case는 비즈니스 로직만 담당)
    return {
      id: questionId,
      title: input.title,
      content: input.content,
      category: input.category,
      section: "inquiries",
      is_active: true,
      created_at: new Date().toISOString(),
    } as QuestionResponse;
  }
}

export const updateQuestionUseCase = new UpdateQuestionUseCase();
